import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import React, { useState } from "react";
import './App.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import RequestsPage from "./RequestsPage/RequestsPage";
import { Home } from './Home/Home';
import Header from './Layout/Components/Header';
import SideBar from './Layout/Components/SideBar';
import RequestsList from "./RequestsPage/RequestsList/RequestsList";
import MeetingPage from "./MeetingPage/MeetingPage";
import MeetingsList from "./MeetingsList/MeetingsList";
import Second_SideBar from "./Second_SideBar/Second_SideBar";
import AddMeetingModal from './Home/Components/AddMeetingModal';
import AddRequestModal from './Home/Components/AddRequestModal';
import AddTaskComponent from './Home/Components/AddTaskComponent';
import MyTasks from './MyTasks/MyTask';
import TaskAssigned from './TaskAssigned/TaskAssigned';
import CalendarPermissionsPage from './CalendarPermissions/CalendarPermissionsPage';
import MyCalendar from './MyCalendarPage/MyCalendarPage';

// SidebarManager (unchanged, but we'll move it inside AppContent)
function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

function AppContent() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeModal, setActiveModal] = useState(null);
  const location = useLocation();
  const isHome = location.pathname === "/";
  const { user } = useAuth();

  // If not logged in and not on auth pages, let ProtectedRoute handle redirection
  // But we'll use ProtectedRoute on each route

  return (
    <div className="w-full h-screen flex flex-col bg-[#f8fafc] overflow-hidden" dir="rtl">
      {user && <Header onMenuToggle={() => setIsSidebarOpen(true)} />}

      <div className="flex flex-1 w-full overflow-hidden relative">
        {user && isHome && (
          <SideBar 
            isOpen={isSidebarOpen} 
            onClose={() => setIsSidebarOpen(false)} 
            setActiveModal={setActiveModal} 
          />
        )}
        {user && !isHome && (
          <div className="hidden md:block h-full"><Second_SideBar /></div>
        )}
        
        <div className="flex-1 h-full overflow-y-auto">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/requests" element={<ProtectedRoute><RequestsPage /></ProtectedRoute>} />
            <Route path="/requestsList" element={<ProtectedRoute><RequestsList /></ProtectedRoute>} />
            <Route path="/requests-board" element={<ProtectedRoute><RequestsList /></ProtectedRoute>} />
            <Route path="/meetings" element={<ProtectedRoute><MeetingPage /></ProtectedRoute>} />
            <Route path="/meetingsList" element={<ProtectedRoute><MeetingsList /></ProtectedRoute>} />
            <Route path="/mytasks" element={<ProtectedRoute><MyTasks /></ProtectedRoute>} />
            <Route path="/taskassigned" element={<ProtectedRoute><TaskAssigned /></ProtectedRoute>} />
            <Route path="/mycalendar" element={<ProtectedRoute><MyCalendar /></ProtectedRoute>} />
            <Route path="/calendar-permissions" element={<ProtectedRoute><CalendarPermissionsPage /></ProtectedRoute>} />
          </Routes>
        </div>
      </div>

      {/* Modals (unchanged) */}
      {activeModal === 'meeting' && <AddMeetingModal isOpen={true} onClose={() => setActiveModal(null)} />}
      {activeModal === 'request' && <AddRequestModal onClose={() => setActiveModal(null)} />}
      {activeModal === 'task' && <AddTaskComponent onClose={() => setActiveModal(null)} />}
    </div>
  );
}

export default App;